module.exports = __webpack_public_path__ + "img/product-preview-20.b25a9b0.png";